import { render, staticRenderFns } from "./Yritys.vue?vue&type=template&id=434c5b66&"
import script from "./Yritys.vue?vue&type=script&lang=js&"
export * from "./Yritys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports